<template>
  <div class="layout case">
		<router-view />
		<Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
	components: {
		Footer
	}
}
</script>
